module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/core-js/library/modules/_add-to-unscopables.js
// module id = SXcY
// module chunks = 15